import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
//window.axios = require('axios')
// import VueSlideBar from 'vue-slide-bar'
import axios from 'axios'

import VuejsDialog from 'vuejs-dialog';

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)
//  Vue.use('VueSlideBar', VueSlideBar)
import Api from "./mixins/Apicall";
import Appsettings from "./mixins/AppSettings";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueI18n from 'vue-i18n'
import { ENGLISH_TRANSLATIONS } from '@/localization/en';
import { IRISH_TRANSLATIONS } from '@/localization/ga';

Vue.config.productionTip = false
let app = '';

Vue.use(VueI18n)

Vue.prototype.$http = axios;

Vue.mixin(Api);

Vue.mixin(Appsettings);

Vue.use(VuejsDialog);

const TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  ga: IRISH_TRANSLATIONS
}
const i18n = new VueI18n({
  locale: 'en',
  messages: TRANSLATIONS,
})

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: "AIzaSyDnyzwL13VFXV0sePVOLY_GRd5ciScwbTw",
  authDomain: "st-ives-d8044.firebaseapp.com",
  projectId: "st-ives-d8044",
  storageBucket: "st-ives-d8044.appspot.com",
  messagingSenderId: "607994356463",
  appId: "1:607994356463:web:a83680bc6632dc6095711a",
  measurementId: "G-F487DZB2YR",
  databaseURL: "https://st-ives-d8044.firebaseio.com"
};


firebase.initializeApp(config);

const analytics = firebase.analytics();
export const dataBase = firebase.database();

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      firebase,
      i18n,
      render: h => h(App)
    }).$mount('#app')

    window.app = app;
  }
});

